<template>
  <div>
    <p class="titleP">申请结果</p>
    <Card class="cardStyle">
      <Form :disabled="disabled" :label-width="85" label-position="left" class="formStyle">
       
        <Icon class="Item1" type="ios-checkmark-circle" size="65" color="#1DBF6D"></Icon>
        <br/>
        <span class="Item2">申请成功</span>
        <br/>
        <div class="Item3"><br/><span style="margin-left: 30px;">已提交申请</span><br/></div>
        <br/>
        <Button class="Item4" type="primary" @click="openApplyPage">返回发起申请</Button>
        <br />
      </Form>  
      <Button class="Item5" @click="openHistoryApplyPage">查看申请状况</Button>
    </Card>
    
  </div>
</template>
<script>
export default {
  props: {
    formItem: {},
    disabled: false,
  },
  data() {
    return {
      textArea: "",
    };
  },
  methods: {
    openApplyPage() {
      this.$router.push("/4B52EF0102B25075C587E33DA46A7207/A3FFBEBFDB713E27")
    },
    openHistoryApplyPage() {
      this.$router.push("/EE8D3DF28FEFA1026138E1506FB19594/A3FFBEBFDB713E27")
    },
  },
};
</script>
<style scoped>
.titleP {
  font-size: 20px;
  color: #17233d;
  height: 40px;
  width: 100%;
}
.cardStyle {
  height: 350px;
  position: relative;
}
.formStyle {
  position: absolute;
  left: 47%;
  width: 100%;
}
.Item1 {
  margin-left: 20px;
}
.Item2 {
  font-size: 27px;
  color: #17233d;
  margin-top: 55px;
}
.Item3 {
  position: absolute;
  background-color: #edfff3;
  border: 1px solid #8ce6b0;
  border-radius: 5px;
  width: 50%;
  height: 60px;
  left: -22%;
  margin-top: 15px;
}
.Item4 {
  position: absolute;
  margin-top: 90px;
}
.Item5 {
  margin-top: 280px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/Component/applyAfterPage.vue